// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Sprint 62.57.0 (Slice F, AC-F1) — a receipt of the dossier by the authority,
 * as a person evidenced it.
 *
 * The governing text is keyed on this date and on nothing else: never the
 * record's creation, its submission instant, server time or today. Append-only;
 * a correction is a new entry naming {@link correction_of}.
 */
export const DOSSIER_RECEIPT_EVENTS = [
    'dossier_received',
    'complete_dossier_received',
    // Sprint 62.57.0 (Slice C, D31): the authority's receipt of a completion
    // submitted after a result. Never re-stamps the governing text (LQ-3).
    'completed_dossier_received',
];
export const GOVERNING_TEXT_NOT_DETERMINED_REASONS = [
    'receipt_not_evidenced',
    'no_declaration',
    'receipt_outside_declared_windows',
    'declaration_unreadable',
];
//# sourceMappingURL=governing-text.js.map